define( function() {
	"use strict";

	return Object.getPrototypeOf;
} );



//////////////////
// WEBPACK FOOTER
// ./node_modules/jquery/src/var/getProto.js
// module id = 0oQ4
// module chunks = 0 1